// src/authz.js
import { useAuth0 } from "@auth0/auth0-react";

export const NAMESPACE = "https://til.app/claims";

export function useRoles() {
  const { user } = useAuth0();
  return (user?.[`${NAMESPACE}/roles`] || []);
}

// ✅ New helper — adds active org support
export function useActiveOrgId() {
  const { user } = useAuth0();
  return user?.[`${NAMESPACE}/org_id`] || null; // requires your Auth0 Action to set this claim
}

export function useActiveOrgSlug() {
  const { user } = useAuth0();
  return user?.[`${NAMESPACE}/org_name`] || null; // slug like "fund-alpha"
}

export function RequireOrg({ org, orgs, children }) {
  const activeSlug = useActiveOrgSlug();
  const allow = orgs ?? (org ? [org] : []);
  if (!activeSlug || !allow.includes(activeSlug)) return null;
  return <>{children}</>;
}

export function RequireRole({ roles, children }) {
  const { isAuthenticated } = useAuth0();
  const userRoles = useRoles();

  // roles can be a single string or an array
  const required = Array.isArray(roles) ? roles : [roles];

  const hasRole =
    isAuthenticated && userRoles.some((r) => required.includes(r));

  if (!hasRole) return null;
  return <>{children}</>;
}